import { apiHelper, authHelper } from '@/utils';
import { API } from '@/constants';
import { IHEXTAR_AUTH } from '@/constants';

export const authService = {
    login,
    refresh,
	loginOtpRequest,
	loginOtpVerify,
	forgotPasswordOtpRequest,
	forgotPasswordOtpVerify,
	resetPasswordVerify,
    logout,
};

const MODULE = {
    AUTH: 'auth',
};

const API_URL = API.BASE_URL_APP + '/v1';

export async function login (data) {
    const request = {
        email: data.email,
        password: await authHelper.AESEncryptPassword(data.password),
        device_token: null,
        iv: IHEXTAR_AUTH.KEY_IV,
    };

    return apiHelper(API_URL, false, false).post(`/${MODULE.AUTH}/login`, request);
}

export function refresh () {
    return apiHelper(API_URL).post(`/${MODULE.AUTH}/refresh`);
}

export function loginOtpRequest (data) {
    const request = {
        method: 1, // email
        email: data.email,
    };

    return apiHelper(API_URL, false, false).post(`/${MODULE.AUTH}/login-otp-request`, request);
}

export function loginOtpVerify (data) {
    const request = {
        method: 1, // email
        email: data.email,
        otp: data.otp,
        device_token: null,
    };

    return apiHelper(API_URL, false, false).post(`/${MODULE.AUTH}/login-otp-verify`, request);
}

export function forgotPasswordOtpRequest (data) {
    const request = {
        method: 1, // email
        email: data.email,
    };

    return apiHelper(API_URL, false, false).post(`/${MODULE.AUTH}/forgot-password-otp-request`, request);
}

export function forgotPasswordOtpVerify (data) {
    const request = {
        method: 1, // email
        email: data.email,
        otp: data.otp,
    };

    return apiHelper(API_URL, false, false).post(`/${MODULE.AUTH}/forgot-password-otp-verify`, request);
}

export async function resetPasswordVerify (data) {
    const request = {
        method: 1, // email
        user_uuid: data.userUuid,
        otp: data.otp,
        password: await authHelper.AESEncryptPassword(data.password),
        iv: IHEXTAR_AUTH.KEY_IV,
    };

    return apiHelper(API_URL, false, false).post(`/${MODULE.AUTH}/reset-password-verify`, request);
}

export function logout () {
    return apiHelper(API_URL).post(`/${MODULE.AUTH}/logout`);
}
